import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Calibrate from "./pages/Calibrate";
import ContentEditor from "./pages/ContentEditor";
import BotFarm from "./pages/BotFarm";
import BalanceDashboard from "./pages/BalanceDashboard";
import ModBench from "./pages/ModBench";
import UpdateBanner from "./components/UpdateBanner";
import { loadBalanceOverrides } from "./game/balanceOverrides";
import { initBalanceData } from "./game/balanceData";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/calibrate"} component={Calibrate} />
      <Route path={"/content-editor"} component={ContentEditor} />
      <Route path={"/bot-farm"} component={BotFarm} />
      <Route path={"/balance"} component={BalanceDashboard} />
      <Route path={"/mods"} component={ModBench} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  // BETA 21.62 — load dev balance overrides from Supabase + apply them to the live
  // game data once at startup, so dashboard-tuned numbers take effect in runs even
  // when the dashboard isn't open this session.
  useEffect(() => {
    void loadBalanceOverrides().then(() => initBalanceData());
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
          {/* Global update notification — shows on any screen when a new version is live */}
          <UpdateBanner />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
